import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{staticClass:"display-only",attrs:{"readonly":"","label":_vm.label,"value":_vm.value,"placeholder":_vm.placeholder,"hide-details":"auto"}})}
var staticRenderFns = []

export { render, staticRenderFns }